module.exports = __webpack_public_path__ + "img/party.7165ce4e.svg";